// « 💬 Ton avis » (D-103) : un avis est un message au support avec un sujet (même table, mêmes règles :
// l'auteur lit les siens, le club ne lit rien, l'équipe Arceau lit tout). Le bouton paraît pour les clubs
// pilotes (support_avis_open) ; la boîte du support lit les sujets et le décompte de la semaine.
import { supabase } from './supabase';
import type { AvisOthers, AvisTopic, SupportKind } from '../help/support';

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};

const known = new Map<string, boolean>();
const asking = new Map<string, Promise<boolean>>();
/** Le bouton « Ton avis » s'ouvre-t-il pour ce club (formule pilote) ? Demandé une fois par club. */
export function avisOpen(clubId: string): Promise<boolean> {
  const k = known.get(clubId);
  if (k !== undefined) return Promise.resolve(k);
  let p = asking.get(clubId);
  if (!p) {
    p = Promise.resolve(db().rpc('support_avis_open', { p_club: clubId }))
      .then(r => r.data === true, () => false)
      .then(on => { known.set(clubId, on); asking.delete(clubId); return on; });
    asking.set(clubId, p);
  }
  return p;
}
/** La réponse déjà connue (sans attendre), pour poser le bouton dès le premier dessin. */
export const avisOpenKnown = (clubId: string): boolean | undefined => known.get(clubId);

export interface AvisDraft {
  club_id: string; topic: AvisTopic; kind: SupportKind; body: string; for_other_clubs: AvisOthers | null;
  page: string | null; page_label: string | null; app_version: string | null; user_agent: string | null;
  casquette: string | null; screenshot: string | null;
}
/** Envoie un avis ; l'erreur garde son code (54000 : 10 messages par jour atteints). */
export async function sendAvis(d: AvisDraft): Promise<void> {
  const { error } = await db().from('support_messages').insert(d);
  if (error) throw Object.assign(new Error(error.message), { code: error.code });
}

/** Boîte du support : le sujet, « autres clubs » et la page des avis (les admins de la plateforme lisent tout). */
export interface AvisMeta { id: string; topic: AvisTopic; for_other_clubs: AvisOthers | null; page_label: string | null }
export async function avisMeta(): Promise<AvisMeta[]> {
  const { data, error } = await db().from('support_messages').select('id, topic, for_other_clubs, page_label')
    .not('topic', 'is', null).order('created_at', { ascending: false }).limit(300);
  if (error) throw new Error(error.message);
  return (data ?? []) as AvisMeta[];
}

/** Décompte des avis par semaine (lundi), sujet et page : le point hebdomadaire de la tâche SAV. */
export interface AvisWeek { week: string; topic: AvisTopic; page: string; messages: number; for_other_clubs: number; clubs: number }
export async function avisWeekly(weeks = 8): Promise<AvisWeek[]> {
  const { data, error } = await db().rpc('support_avis_weekly', { p_weeks: weeks });
  if (error) throw new Error(error.message);
  return (data ?? []) as AvisWeek[];
}
